import CookieJs from 'js-cookie';
import ConversorDeData from '../helpers/conversorDeDataHelper';

export default class Cookie {

    static definir(identificador, valor, tempoDeExpiracaoEmMinutos = 60) {
        const tempoEmDate = ConversorDeData.transformaDeMinutosParaData(tempoDeExpiracaoEmMinutos);
        CookieJs.set(identificador, valor, { expires: tempoEmDate });
    } 

    static obter(identificador) {
        return CookieJs.get(identificador);
    }

    static remover(identificador) {
        CookieJs.remove(identificador);
    }
    
}